/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Understandingrolesintro3Inputs */

const en_usermanagement_help_understandingrolesintro3 = /** @type {(inputs: Usermanagement_Help_Understandingrolesintro3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are two key phases that require different sets of permissions and roles: the <b>Offering Phase</b> and the <b>Investment Phase</b>.`)
};

/**
* | output |
* | --- |
* | "There are two key phases that require different sets of permissions and roles: the <b>Offering Phase</b> and the <b>Investment Phase</b>." |
*
* @param {Usermanagement_Help_Understandingrolesintro3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_understandingrolesintro3 = /** @type {((inputs?: Usermanagement_Help_Understandingrolesintro3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Understandingrolesintro3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_understandingrolesintro3(inputs)
});
export { usermanagement_help_understandingrolesintro3 as "userManagement_help_understandingRolesIntro" }